import PropTypes from 'prop-types';

export const isResultPropType = PropTypes.bool;
